import React from 'react';
import { Navigation } from './components/navigation';
import { Header } from './components/header';
import { Pricing } from './components/pricing';
import { Gallery } from './components/portfolio';
import { Statement } from './components/statement';
import { Contacts } from './components/contacts';
import { Footer } from './components/footer'

import './style.css'

function App() {
  return (
    <>
      <Navigation />
      <Header />
      <Gallery />
      <Pricing />
      <Statement />
      {/*<Contacts />*/}
      <Footer />
    </>
  );
}

export default App;
